module.exports = __webpack_public_path__ + "static/media/bbc_news_election-us-2016-37450661_plot.0146d2d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_election-us-2016-37450661_plot.png
// module id = 344
// module chunks = 0